import React from "react";
import { Copyright } from "../../components/copyright";

export const LifeStyle = () => {
  return (
			<section className="right-section not-home-page">
				<div className="flex-container">
					<div className="item">
						<img src="imgs/lifestyle/Raphaela-Tavarone-1.jpg" alt="Raphaela Tavarone Jewelry"/>
					</div>
					<div className="item">
						<img src="imgs/lifestyle/Raphaela-Tavarone-4.jpg" alt="Raphaela Tavarone Jewelry"/>
					</div>
					<div className="item">
						<img src="imgs/lifestyle/Raphaela-Tavarone-3.jpg" alt="Raphaela Tavarone Jewelry"/>
					</div>
					<div className="item">
						<img src="imgs/lifestyle/antique-ring.jpg" alt="antique ring with flower background"/>
					</div>
					<div className="item">
						<img src="imgs/lifestyle/three-gemstone-rings.jpg" alt="antique ring with flower background"/>
					</div>
					<div className="item">
						<img src="imgs/lifestyle/pendant-on-crystal.jpg" alt="pendant on crystal"/>
					</div>
					<div className="item">
						<img src="imgs/lifestyle/whiskey-glass.jpg" alt="whiskey glass"/>
					</div>
				</div>
				<Copyright />
		</section>
  )
};
